<template>
  <div class="col-12">
    <h2>Compare us with others!</h2>
    <p>Let's take a look what alternatives to ProxyScrape premium have to offer, so you make the
      perfect choice!<br></p>
    <div class="table-responsive">
      <table class="table table-striped text-successtable-border border-light"
             style="border-radius: 7px; overflow: hidden;">
        <thead class="border-light">
        <tr id="logotable">
          <th scope="col"></th>
          <th scope="col"><img alt="ProxyScrape logo"
                               src="https://cdn.proxyscrape.com/img/logo/dark_text_logo.png">
          </th>
          <th scope="col"><img alt="Webshare logo"
                               src="https://cdn.proxyscrape.com/img/websharelogo.png"></th>
          <th scope="col"><img alt="Proxyrack logo"
                               src="https://cdn.proxyscrape.com/img/proxyrack_logo.png"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <th scope="row">1000 proxies price</th>
          <td>$24</td>
          <td>$26.91</td>
          <td>Not available (minimum 20 000 proxies)</td>
        </tr>
        <tr>
          <th scope="row">Largest available package</th>
          <td>50 000 proxies</td>
          <td>60 000 proxies</td>
          <td>20 000 proxies</td>
        </tr>
        <tr>
          <th scope="row">Unlimited bandwidth</th>
          <td>Yes - free of charge</td>
          <td>Starting from $107.64</td>
          <td>Yes - free of charge</td>
        </tr>
        <tr>
          <th scope="row">Maximum concurrent connections</th>
          <td>Unlimited</td>
          <td>500 (upgrades available)</td>
          <td>100 (upgrades available)</td>
        </tr>
        <tr>
          <th scope="row">IP authentication slots</th>
          <td>3 (upgrades available)</td>
          <td>1 (upgrades available)</td>
          <td>50</td>
        </tr>
        <tr>
          <th scope="row">Support</th>
          <td>Live chat &amp; email</td>
          <td>Email</td>
          <td>Email</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>
#logotable th img {
  max-height: 25px;
}
</style>
